import { classNames } from '@/utils'
import { Loader } from 'lucide-react'

import React from 'react'

interface ContentLoaderProps {
  classes?: {
    container?: string
  }
  showText?: boolean
}

const ContentLoader: React.FC<ContentLoaderProps> = (props) => {
  const { classes, showText = true } = props
  return (
    <>
      <div className={classNames('h-[250px] flex justify-center items-center', classes?.container)}>
        <div className="flex items-center gap-[10px]">
          <Loader color="black" size={32} />
          {showText && <span>Loading</span>}
        </div>
      </div>
    </>
  )
}

export { ContentLoader }
